import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { testManagementToolIntegration } from '../../docs-routes'

const TestManagementToolIntegrations = () =>
  <Paragraph>
    <Color variant='theme-description-text'>
      Integrate your preferred test management tools with DAI to streamline test case syncing and reporting. Connect once to keep your test cases, requirements, and execution results automatically aligned between systems.
    </Color>
    <DocusaurusFooter path={testManagementToolIntegration} />
  </Paragraph>

export default TestManagementToolIntegrations
